var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCandidate || _vm.isInvestor)?_c('index-candidate'):_c('index-auth')
}
var staticRenderFns = []

export { render, staticRenderFns }